import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function GsapDText1({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');
    return (
        <div className={`${css.gsapDText1} gsapDText1`}>
            <div className="msg-title">{t('smart_home_panel.eleven_title')}</div>
            <div
                className="msg-line1"
                dangerouslySetInnerHTML={{
                    __html: t('smart_home_panel.eleven_subtitle'),
                }}
            ></div>
        </div>
    );
}
